var SupportMarketRateImagePresenterPresentation;

SupportMarketRateImagePresenterPresentation = (function() {
  function SupportMarketRateImagePresenterPresentation() {}

  SupportMarketRateImagePresenterPresentation.prototype.present = function(images) {
    var image, parts, ref, url;
    if (!((images != null ? images.length : void 0) > 0)) {
      return null;
    }
    image = _.first(images);
    url = image != null ? image.url : void 0;
    if (url != null) {
      if (!(((ref = url.match(/http/)) != null ? ref.index : void 0) === 0 || url.indexOf("//") === 0)) {
        url = "https://" + url;
      }
      parts = url.split("/v1/");
      if ((_.last(parts)) === '') {
        parts = _.initial(parts);
      }
      if (parts != null) {
        return _.reduce(parts, function(memo, part) {
          return memo + "/" + part;
        });
      }
    }
  };

  return SupportMarketRateImagePresenterPresentation;

})();

module.exports = SupportMarketRateImagePresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9tYXJrZXRfcmF0ZV9pbWFnZV9wcmVzZW50ZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9tYXJrZXRfcmF0ZV9pbWFnZV9wcmVzZW50ZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQU07Ozt3REFDSixPQUFBLEdBQVMsU0FBQyxNQUFEO0FBQ1AsUUFBQTtJQUFBLElBQUEsQ0FBQSxtQkFBbUIsTUFBTSxDQUFFLGdCQUFSLEdBQWlCLENBQXBDLENBQUE7QUFBQSxhQUFPLEtBQVA7O0lBQ0EsS0FBQSxHQUFRLENBQUMsQ0FBQyxLQUFGLENBQVEsTUFBUjtJQUNSLEdBQUEsbUJBQU0sS0FBSyxDQUFFO0lBQ2IsSUFBRyxXQUFIO01BQ0UsSUFBQSxDQUFBLHlDQUF3QixDQUFFLGVBQW5CLEtBQTRCLENBQTVCLElBQWlDLEdBQUcsQ0FBQyxPQUFKLENBQVksSUFBWixDQUFBLEtBQXFCLENBQTdELENBQUE7UUFDRSxHQUFBLEdBQU0sVUFBQSxHQUFXLElBRG5COztNQUVBLEtBQUEsR0FBUSxHQUFHLENBQUMsS0FBSixDQUFVLE1BQVY7TUFDUixJQUErQixDQUFFLENBQUMsQ0FBQyxJQUFGLENBQU8sS0FBUCxDQUFGLENBQUEsS0FBb0IsRUFBbkQ7UUFBQSxLQUFBLEdBQVUsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxLQUFWLEVBQVY7O01BQ0EsSUFBRyxhQUFIO2VBQWUsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxLQUFULEVBQWdCLFNBQUMsSUFBRCxFQUFPLElBQVA7aUJBQW1CLElBQUQsR0FBTSxHQUFOLEdBQVM7UUFBM0IsQ0FBaEIsRUFBZjtPQUxGOztFQUpPOzs7Ozs7QUFXWCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
